import {useQuery, type UseQueryOptions} from 'react-query';
import {
	fetchPaymentWay,
	type FetchPaymentWayPath,
	type FetchPaymentWayResponse,
} from '../../http/paymentWays/fetchPaymentWay';

export function useFetchPaymentWay(
	path: FetchPaymentWayPath | null,
	options?: Omit<UseQueryOptions<FetchPaymentWayResponse>, 'queryKey' | 'queryFn'>,
) {
	return useQuery<FetchPaymentWayResponse>({
		...options,
		queryKey: ['paymentWay', path?.type, path?.id],
		enabled: Boolean(path) && (options?.enabled ?? true),
		queryFn: async ({signal}) => {
			if (!path) {
				throw new Error('payment way path is required');
			}

			const {data} = await fetchPaymentWay(path, signal);

			return data;
		},
	});
}
